import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Phone, Mail } from "lucide-react";
import { COMPANY, NAV, CONTACT } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-raritan-green text-white">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-12 border-b border-white/15 pb-16">
        <div className="lg:col-span-5">
          <div className="font-heading font-extrabold text-3xl leading-[0.85] mb-6">
            <span className="text-raritan-red">RARITAN</span>
            <br />
            <span className="text-white">GROUP</span>
          </div>
          <p className="text-white/70 font-body max-w-md leading-relaxed">{COMPANY.tagline}</p>
          <p className="mt-8 font-serif italic text-xl text-white/90">&ldquo;{COMPANY.motto}&rdquo;</p>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 mb-5">Navigate</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.label.toLowerCase()}`}
                  className="group inline-flex items-center gap-1.5 text-white/80 hover:text-white transition-colors"
                >
                  {n.label}
                  <ArrowUpRight size={13} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 mb-5">Get in touch</h4>
          <div className="flex gap-3 mb-4">
            <MapPin size={18} className="text-raritan-red shrink-0 mt-0.5" />
            <p className="text-white/80 leading-relaxed">{CONTACT.office}</p>
          </div>
          {CONTACT.phones.map((p) => (
            <a key={p} href={`tel:${p}`} className="flex gap-3 mb-3 text-white/80 hover:text-white transition-colors">
              <Phone size={18} className="text-raritan-red shrink-0" />
              {p}
            </a>
          ))}
          {CONTACT.emails.map((e) => (
            <a key={e} href={`mailto:${e}`} className="flex gap-3 mb-3 text-white/80 hover:text-white transition-colors break-all">
              <Mail size={18} className="text-raritan-red shrink-0" />
              {e}
            </a>
          ))}
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.15em] text-white/50">
        <p>© {new Date().getFullYear()} Raritan Group. All rights reserved.</p>
        <p>Raritan Consulting & Information Services India Pvt. Ltd. · Raritan Karmanya Foundation</p>
      </div>
    </div>
  </footer>
);
